import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import imgArrowLeft from '../../images/common/ic_arrow_left.svg';
import imgArrowRight from '../../images/common/ic_arrow_right.svg';
import imgArrowDLeft from '../../images/common/ic_arrow_double_left.svg';
import imgArrowDRight from '../../images/common/ic_arrow_double_right.svg';
import ColorSF2 from '../../styles/common/ColorSF2';

const Main = styled.div`
  flex: 0 0 auto;
  height: 48px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: ${ColorSF2.paleBlue};
  padding: 0 10px;
  @media (max-width: 830px), (max-height: 530px) {
    height: 30px;
  }
`;
const style = {
  main: {
    flex: '0 0 auto',
    height: 48,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#40528b',
    padding: '0 10px',
  },
  pagenation: {
    display: 'flex',
    flexDirection: 'row',
    margin: '0 10px',
    height: 26,
  },
  pageRight: {
    minWidth: 60,
    color: ColorSF2.black,
    textAlign: 'right',
  },
  page: {
    marginLeft: 1,
    cursor: 'pointer',
    border: '1px solid #fff',
    width: 38,
    height: '100%',
    fontSize: 12,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  currentPage: {
    border: '0px solid #fff',
    backgroundColor: '#fff',
    color: '#43528A',
    width: 38,
    height: '100%',
    fontSize: 12,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  next: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    color: '#fff',
    cursor: 'pointer',
  },
  prev: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    color: '#fff',
    cursor: 'pointer',
  },
  angle: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
};

const TOP_PAGE = 1;
const DISPLAY_PAGE = 7;
const DISPLAY_CENTER = 3;

const createPagenation = (pagenation, searchOptions, onSelect) => {
  const currentPage = (searchOptions && searchOptions.page) || 1;
  const { totalPages } = pagenation;
  const prevPage = currentPage - 1 > 0 ? currentPage - 1 : currentPage;
  const nextPage =
    currentPage + 1 <= totalPages ? currentPage + 1 : currentPage;
  let firstPage =
    currentPage > DISPLAY_PAGE - 1 ? currentPage - DISPLAY_CENTER : TOP_PAGE;
  let lastPage =
    currentPage > DISPLAY_PAGE - 1
      ? currentPage + DISPLAY_CENTER
      : DISPLAY_PAGE;
  if (lastPage > totalPages) {
    lastPage = totalPages;
    firstPage = totalPages - (DISPLAY_PAGE - 1);
  }
  if (firstPage < TOP_PAGE) {
    firstPage = TOP_PAGE;
  }
  const pageCount = lastPage - firstPage + 1;
  return (
    <div style={style.pagenation}>
      <div
        className="clickableItem"
        id="timelinePagenationMoveToStartButton"
        role="presentation"
        style={style.prev}
        key="moveToStartButton"
        onClick={() => onSelect(1)}
      >
        <img style={style.angle} src={imgArrowDLeft} alt="" />
      </div>
      <div
        className="clickableItem"
        id="timelinePagenationPrevButton"
        role="presentation"
        style={style.prev}
        key="prevButton"
        onClick={() => onSelect(prevPage)}
      >
        <img style={style.angle} src={imgArrowLeft} alt="" />
      </div>
      <div style={style.pagenation}>
        {[...Array(pageCount)].map((_, i) => {
          const count = i + firstPage;
          const styleColor =
            count === currentPage ? style.currentPage : style.page;
          const clickableClassName =
            count !== currentPage ? 'pagenationClickable' : '';
          return (
            <div
              className={clickableClassName}
              id={`timelinePagenationCount${i}`}
              role="presentation"
              style={styleColor}
              key={`${count}`}
              onClick={() => onSelect(count)}
            >
              <div>{count}</div>
            </div>
          );
        })}
      </div>
      <div
        className="clickableItem"
        id="timelinePagenationNextButton"
        role="presentation"
        style={style.next}
        key="nextButton"
        onClick={() => onSelect(nextPage)}
      >
        <img style={style.angle} src={imgArrowRight} alt="" />
      </div>
      <div
        className="clickableItem"
        id="timelinePagenationMoveToEndButton"
        role="presentation"
        style={style.next}
        key="moveToEndButton"
        onClick={() => onSelect(totalPages)}
      >
        <img style={style.angle} src={imgArrowDRight} alt="" />
      </div>
    </div>
  );
};

const TimeLinePagenation = ({ pagenation, searchOptions, onSelect }) => {
  const totalNumber = (pagenation && pagenation.totalNumber) || 0;
  const totalPages = (pagenation && pagenation.totalPages) || 0;
  return (
    <Main id="timeLinePagenation">
      <div />
      {(totalPages > 1 &&
        createPagenation(pagenation, searchOptions, onSelect)) || <div />}
      <div style={style.pageRight}>
        {totalNumber}
        <FormattedMessage id="timeline.pagenation.unit" />
      </div>
    </Main>
  );
};

TimeLinePagenation.propTypes = {
  pagenation: PropTypes.object.isRequired,
  searchOptions: PropTypes.object.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default TimeLinePagenation;
